module.exports = __webpack_public_path__ + "img/employee.4a480b50.png";